import { jsx as _jsx } from "react/jsx-runtime";
import logoDark from 'assets/logo-dark.svg';
export default function Logo({ width, className }) {
    return _jsx("img", { alt: "", className: className, src: logoDark, width: width });
}
